import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useAuth } from '@/lib/auth'
import { hasSuperAdminAccess } from '@/lib/permissions'
import { useSystemFeatureVisibility } from '@/lib/system-feature-visibility'
import { Save } from 'lucide-react'

export default function SettingsRoute() {
  const { user, isLoading } = useAuth()
  const featureVisibility = useSystemFeatureVisibility()
  const canViewSettings = hasSuperAdminAccess(user)

  if (isLoading) {
    return <div className="grid min-h-dvh place-items-center text-sm text-slate-500">載入中...</div>
  }

  if (!canViewSettings) {
    return (
      <div className="grid min-h-dvh place-items-center bg-slate-50 p-6 text-center">
        <div>
          <h1 className="text-lg font-semibold text-slate-950">沒有設定管理權限</h1>
          <p className="mt-2 text-sm text-slate-500">設定頁預設只開放給超級管理員。</p>
        </div>
      </div>
    )
  }

  return (
    <div className="flex max-w-6xl flex-col gap-5 p-4 lg:p-6">
      <div>
        <div className="flex flex-wrap items-center gap-2">
          <h1 className="text-2xl font-semibold">設定</h1>
          {featureVisibility['runtime.statusBadges'] ? (
            <Badge variant="outline">mock-safe provider mode</Badge>
          ) : null}
        </div>
        <p className="mt-1 text-sm text-slate-500">
          工作區基本設定。外部 provider 目前都保持未接線狀態。
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>工作區</CardTitle>
        </CardHeader>
        <CardContent className="grid max-w-xl gap-4">
          <div className="grid gap-2">
            <Label>工作區名稱</Label>
            <Input defaultValue="MiaoForm Internal Workspace" />
          </div>
        </CardContent>
      </Card>

      <Button className="self-start">
        <Save className="size-4" />
        儲存設定
      </Button>
    </div>
  )
}
